export type WidgetTheme = "light" | "dark" | "auto";

export const DEFAULT_WIDGET_THEME: WidgetTheme = "auto";

const WIDGET_THEMES: readonly WidgetTheme[] = ["light", "dark", "auto"];

function parseWidgetTheme(value: string | null | undefined): WidgetTheme | undefined {
  const normalised = value?.trim().toLowerCase();
  return WIDGET_THEMES.find((theme) => theme === normalised);
}

export function normaliseWidgetTheme(value: string | null | undefined): WidgetTheme {
  return parseWidgetTheme(value) ?? DEFAULT_WIDGET_THEME;
}

export function resolveWidgetTheme(attributeValue: string | undefined, search: string): WidgetTheme {
  const queryTheme = parseWidgetTheme(new URLSearchParams(search).get("theme"));
  return queryTheme ?? normaliseWidgetTheme(attributeValue);
}

export type ColourScheme = "light" | "dark";

export function resolveColourScheme(theme: WidgetTheme, prefersDark: boolean): ColourScheme {
  if (theme === "auto") {
    return prefersDark ? "dark" : "light";
  }
  return theme;
}
